export const isCI = () => process.env.CI === '1';
